import { createBrowserHistory } from "redux-first-routing";

export const history = createBrowserHistory()
